//=============================================================
// メガメニュー設定（header.js 読み込み時に即反映）
//=============================================================
window.SignmallMegaMenuConfig = {
  openMode: 'click' // 'hover' or 'click'
};

//=============================================================
// SP時のみ：headlineWrapper を固定化（本文の隠れ防止）
// - PC時は固定なし（通常配置）
// - resize/scroll で高さを取り直して body padding を更新
//=============================================================
jQuery(function ($) {
  'use strict';

  const MOBILE_MAX = 768;
  const $headline = $('.headlineWrapper');
  if (!$headline.length) return;

  let ticking = false;

  function isMobile() {
    return window.matchMedia('(max-width:' + MOBILE_MAX + 'px)').matches;
  }

  function applyHeadlineFixed() {
    if (isMobile()) {
      const h = $headline.outerHeight() || 0;
      $('body').css('padding-top', h + 'px');

      $headline.css({
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        zIndex: 1000,
        background: '#fff'
      });
      return;
    }

    $('body').css('padding-top', '');
    $headline.css({
      position: '',
      top: '',
      left: '',
      right: '',
      zIndex: '',
      background: ''
    });
  }

  function onResizeScroll() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(function () {
      applyHeadlineFixed();
      ticking = false;
    });
  }

  $(window).on('resize scroll', onResizeScroll);
  applyHeadlineFixed();
});


//=============================================================
// タッチデバイスなら hoverTip 無効化（＝即リンク）
//=============================================================
document.addEventListener('DOMContentLoaded', function () {
  if ('ontouchstart' in window) {
    document.querySelectorAll('a.hoverTip').forEach(function (a) {
      a.classList.remove('hoverTip');
    });
  }
});


//=============================================================
// Remodal 初期化・連携（GMM）
//=============================================================
jQuery(function ($) {
  'use strict';

  const $gmm = $('[data-remodal-id=modal_GMM]');
  if ($gmm.length) {
    $gmm.remodal({ hashTracking: false });

    const $wrapper = $gmm.parent();
    if (!$wrapper.attr('id')) {
      $wrapper.attr('id', 'GMMWrapper');
    }
  }
});


/*=============================================================
  メガメニュー制御（PC=hover or click 切替 / SP=click固定）
  - クリック/ホバーはフラグで切替
    window.SignmallMegaMenuConfig = { openMode: 'hover' or 'click' }
  - ホバー対象を a ではなく li.ecItem にする（下端の“隙間”で閉じにくくする）
  - PC固定ヘッダー前提は撤去し、「header の下端」を基準に追従
  - data-directlink="true" は【直接遷移】にする
  - ★追加（要望）：clickモードでも「開いている間は隣liホバーで切替」
  - ★追加（要望）：自分(li)とMegaMenu以外に移動したら閉じる（隣liは切替で対応）
=============================================================*/
jQuery(function ($) {
  'use strict';

  const MOBILE_MAX = 768;
  const isMobile = () => window.matchMedia('(max-width:' + MOBILE_MAX + 'px)').matches;

  const $mega = $('#MegaMenu');
  const $overlay = $('#MegaMenuOverlay');

  // li 側でホバーを拾う（a の下端の隙間問題を回避）
  const $triggerItems = $('.serviceCategory li.ecItem');
  const $triggers = $triggerItems.find('a[data-megamenu]');

  // “ナビ領域” も許可領域に含めたい（ul全体）
  const $navArea = $('.serviceCategory');

  if (!$mega.length || !$overlay.length || !$triggers.length) return;

  //=============================================================
  // 開き方フラグ（hover / click）
  // - SPは常に click（誤爆防止）
  // - PCは openMode で切替
  //=============================================================
  const megaMenuConfig = window.SignmallMegaMenuConfig || {};
  const DESKTOP_OPEN_MODE = (megaMenuConfig.openMode === 'click') ? 'click' : 'hover';

  //=============================================================
  // directlink 判定
  //=============================================================
  const isDirectLink = ($a) => {
    return $a && $a.is('[data-directlink="true"]');
  };

  const isHoverable = window.matchMedia('(hover: hover)').matches;

  let closeTimer = null;

  // clickモードの「開いた起点」を保持（閉じ判定に使う）
  let $activeA = null;
  let $activeItem = null;

  function setActiveTrigger($a) {
    $activeA = $a && $a.length ? $a : null;
    $activeItem = $activeA ? $activeA.closest('li.ecItem') : null;
  }

  function clearActiveTrigger() {
    $activeA = null;
    $activeItem = null;
  }

  // ★★★★★ AJAX関連の変数 ★★★★★
  const ajaxUrl = '/include/header-contents/category.html';

  // 一括プリフェッチ制御
  const PREFETCH_DELAY_MS = 600;
  const IDLE_TIMEOUT_MS = 2000;
  const REVALIDATE_MS = 5 * 60 * 1000;
  const ENABLE_IMAGE_PRELOAD = false;
  const ENABLE_SWR_REVALIDATE = true;

  // キャッシュと状態
  const megaMenuCache = {};
  let prefetchDone = false;
  let prefetching = false;
  let revalidateTimer = null;
  let prefetchStarted = false;

  let loadTimer = null;
  let loadSeq = 0;

  //----- 位置再計算：常に「header の下」へ追従（隙間を作らない）-----
  const updateMegaPositions = () => {
    if (!$mega.hasClass('is-open')) return;

    const headerEl = document.querySelector('header');
    if (!headerEl) return;

    const headerBottom = headerEl.getBoundingClientRect().bottom;

    // overlay / mega を viewport 基準の fixed で揃える
    $overlay.css('top', headerBottom + 'px');

    $mega.css({
      position: 'fixed',
      top: headerBottom + 'px',
      left: 0,
      right: 0
    });

    const availableHeight = window.innerHeight - headerBottom;
    $mega.css('max-height', availableHeight + 'px');
  };

  //----- ARIA更新 -----
  const setAria = (expanded, $trigger) => {
    $triggers.attr({ 'aria-expanded': 'false', 'aria-controls': null });

    if (expanded && $trigger && !isDirectLink($trigger)) {
      $trigger.attr({ 'aria-expanded': 'true', 'aria-controls': 'MegaMenu' });
    }
  };

  // 対象キー（id）一覧を収集
  const getAllKeys = () => {
    const keys = [];
    $triggers.each(function () {
      const $a = $(this);
      if (isDirectLink($a)) return;

      const k = $a.data('megamenu');
      if (k && !keys.includes(k)) keys.push(k);
    });
    return keys;
  };

  const preloadImagesIn = ($root) => {
    if (!ENABLE_IMAGE_PRELOAD) return;
    $root.find('img[src]').each(function () {
      const src = $(this).attr('src');
      if (!src) return;
      const img = new Image();
      img.src = src;
    });
  };

  const prefetchAll = () => {
    if (prefetchDone || prefetching) return;

    const conn = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
    if (conn) {
      if (conn.saveData) return;
      const slow = (conn.effectiveType || '').toLowerCase();
      if (slow.includes('2g')) return;
    }
    if (document.visibilityState !== 'visible') return;

    prefetching = true;
    const keys = getAllKeys();
    if (keys.length === 0) {
      prefetching = false;
      return;
    }

    $.get(ajaxUrl)
      .done(function (html) {
        const $dom = $('<div>').html(html);
        let found = 0;

        keys.forEach((key) => {
          if (megaMenuCache[key]) {
            found++;
            return;
          }

          const $section = $dom.find('#' + key).first();
          if ($section.length) {
            megaMenuCache[key] = $section.prop('outerHTML');
            preloadImagesIn($section);
            found++;
            return;
          }

          megaMenuCache[key] = '<div class="megaMenuInner"><div class="P20"><p>ただいま準備中です。</p></div></div>';
        });

        prefetchDone = (found === keys.length);
      })
      .always(function () {
        prefetching = false;
      });
  };

  const scheduleIdlePrefetch = () => {
    const start = () => {
      if ('requestIdleCallback' in window) {
        window.requestIdleCallback(function () {
          prefetchAll();
        }, { timeout: IDLE_TIMEOUT_MS });
        return;
      }
      setTimeout(prefetchAll, 600);
    };

    setTimeout(function () {
      if (document.visibilityState === 'visible') {
        start();
        return;
      }

      const onVisible = () => {
        if (document.visibilityState === 'visible') {
          document.removeEventListener('visibilitychange', onVisible);
          start();
        }
      };
      document.addEventListener('visibilitychange', onVisible);
    }, PREFETCH_DELAY_MS);
  };

  const revalidateOnce = () => {
    const keys = getAllKeys();
    if (keys.length === 0) return;

    $.get(ajaxUrl).done(function (html) {
      const $dom = $('<div>').html(html);
      keys.forEach((key) => {
        const $section = $dom.find('#' + key).first();
        if ($section.length) {
          megaMenuCache[key] = $section.prop('outerHTML');
          preloadImagesIn($section);
        }
      });
    });
  };

  const scheduleRevalidate = () => {
    if (!ENABLE_SWR_REVALIDATE) return;

    if (revalidateTimer) clearInterval(revalidateTimer);

    revalidateTimer = setInterval(function () {
      if (document.visibilityState !== 'visible') return;

      if ('requestIdleCallback' in window) {
        window.requestIdleCallback(revalidateOnce, { timeout: IDLE_TIMEOUT_MS });
        return;
      }
      setTimeout(revalidateOnce, 800);
    }, REVALIDATE_MS);
  };

  //----- メニューを開く処理 -----
  const openMega = (key, $trigger, opt = {}) => {
    const opts = opt || {};
    const byHoverSwitch = !!opts.byHoverSwitch;

    $overlay.addClass('is-visible');

    // active は a に付ける（既存CSS想定）
    $triggers.removeClass('is-active');
    if ($trigger && $trigger.length) $trigger.addClass('is-active');

    // clickモードで「開いている間に隣へホバー移動」でも active を追従させる
    setActiveTrigger($trigger);

    setAria(true, $trigger);

    if (loadTimer) {
      clearTimeout(loadTimer);
      loadTimer = null;
    }
    const mySeq = ++loadSeq;

    if (megaMenuCache[key]) {
      $mega.html(megaMenuCache[key]).addClass('is-open');
      updateMegaPositions();
      return;
    }

    $mega
      .html(
        '<div class="megaMenuInner">' +
        '<div class="Cnt" style="display:flex;align-items:center;justify-content:center;padding:180px 0;">' +
        '<img src="/assets/images/icon/loadingOvalBlue.svg" alt="読み込み中" width="48" height="48">' +
        '</div>' +
        '</div>'
      )
      .addClass('is-open');

    updateMegaPositions();

    loadTimer = setTimeout(() => {
      const loadUrl = `${ajaxUrl} #${key}`;
      $mega.load(loadUrl, function (response, status) {
        if (mySeq !== loadSeq) return;

        if (status === 'success') {
          const htmlNow = $mega.html();
          megaMenuCache[key] = htmlNow;

          if (ENABLE_IMAGE_PRELOAD) {
            preloadImagesIn($('<div>').html(htmlNow));
          }
        } else {
          $mega.html('<div class="megaMenuInner"><div class="P20"><p>コンテンツの読み込みに失敗しました。</p></div></div>');
        }

        updateMegaPositions();
      });
    }, 0);
  };

  //----- メニューを閉じる処理 -----
  const closeMega = () => {
    if (loadTimer) {
      clearTimeout(loadTimer);
      loadTimer = null;
    }

    $overlay.removeClass('is-visible');
    $mega.removeClass('is-open').empty();

    $triggers.removeClass('is-active');
    setAria(false, null);

    clearActiveTrigger();
  };

  //=============================================================
  // クリック：SPは常に click 開閉
  // PCは openMode=click のときのみ click 開閉
  // openMode=hover のときは「href=#」だけ開く（通常リンクは遷移）
  //=============================================================
  $triggers.on('click', function (e) {
    const $a = $(this);

    if (isDirectLink($a)) {
      closeMega();
      return;
    }

    const key = $a.data('megamenu');
    if (!key) return;

    // SP：常に click
    if (isMobile()) {
      e.preventDefault();
      if ($a.hasClass('is-active') && $mega.hasClass('is-open')) {
        closeMega();
      } else {
        openMega(key, $a);
      }
      return;
    }

    // PC：click運用
    if (DESKTOP_OPEN_MODE === 'click') {
      e.preventDefault();
      if ($a.hasClass('is-active') && $mega.hasClass('is-open')) {
        closeMega();
      } else {
        openMega(key, $a);
      }
      return;
    }

    // PC：hover運用（クリックは極力 “遷移” を優先）
    const href = $a.attr('href') || '';
    if (href === '#') {
      e.preventDefault();
      openMega(key, $a);
    }
  });

  //=============================================================
  // PC hover：openMode=hover のときだけ有効
  //=============================================================
  if (isHoverable && DESKTOP_OPEN_MODE === 'hover') {
    const CLOSE_DELAY_MS = 420;

    $triggerItems.on('mouseenter', function () {
      if (isMobile()) return;
      clearTimeout(closeTimer);

      const $a = $(this).find('a[data-megamenu]').first();
      if (!$a.length) return;
      if (isDirectLink($a)) return;

      const key = $a.data('megamenu');
      if (!key) return;

      openMega(key, $a);
    });

    $triggerItems.on('mouseleave', function () {
      if (isMobile()) return;
      clearTimeout(closeTimer);
      closeTimer = setTimeout(closeMega, CLOSE_DELAY_MS);
    });

    $mega.on('mouseenter', function () {
      if (isMobile()) return;
      clearTimeout(closeTimer);
    });

    $mega.on('mouseleave', function () {
      if (isMobile()) return;
      clearTimeout(closeTimer);
      closeTimer = setTimeout(closeMega, CLOSE_DELAY_MS);
    });
  }

  //=============================================================
  // ★要望版：PC clickモードでも「開いている間は隣liホバーで切替」
  // さらに「ナビ(li群)とMegaMenu以外に出たら閉じる」
  //=============================================================
  if (isHoverable && DESKTOP_OPEN_MODE === 'click') {
    const CLOSE_DELAY_MS = 60; // 触感よく。移動の隙間吸収用

    function isOnAllowedArea(target) {
      if (!target) return false;

      // MegaMenu上
      if ($(target).closest('#MegaMenu').length) return true;

      // ナビ（li群）上：隣に行くときも許可
      if ($navArea.length && $(target).closest($navArea).length) return true;

      return false;
    }

    // 1) 開いている間だけ：隣liにホバーしたら切替（クリック不要）
    $triggerItems.on('mouseenter', function () {
      if (isMobile()) return;
      if (!$mega.hasClass('is-open')) return; // ★開いてない時はhoverで開かない（クリックモード維持）

      clearTimeout(closeTimer);

      const $a = $(this).find('a[data-megamenu]').first();
      if (!$a.length) return;
      if (isDirectLink($a)) return;

      const key = $a.data('megamenu');
      if (!key) return;

      // ★隣に移動したら「切替」
      openMega(key, $a, { byHoverSwitch: true });
    });

    // 2) 許可領域外に出たら閉じる（マウス移動で判定）
    $(document).on('mousemove', function (e) {
      if (isMobile()) return;
      if (!$mega.hasClass('is-open')) return;

      clearTimeout(closeTimer);

      if (isOnAllowedArea(e.target)) {
        return;
      }

      closeTimer = setTimeout(function () {
        const el = document.elementFromPoint(e.clientX, e.clientY);
        if (isOnAllowedArea(el)) return;
        closeMega();
      }, CLOSE_DELAY_MS);
    });

    // 3) MegaMenuに入ったら閉じ予約を止める（体感安定）
    $mega.on('mouseenter', function () {
      if (isMobile()) return;
      clearTimeout(closeTimer);
    });

    // 4) MegaMenuから出たら、外なら閉じる（mousemoveの補助）
    $mega.on('mouseleave', function () {
      if (isMobile()) return;
      clearTimeout(closeTimer);
      closeTimer = setTimeout(function () {
        // 直近のhover先がナビ上なら閉じない（隣切替に繋がる）
        if ($navArea.length && $navArea.is(':hover')) return;
        closeMega();
      }, CLOSE_DELAY_MS);
    });
  }

  //=============================================================
  // 共通：閉じる系
  //=============================================================
  $overlay.on('click', closeMega);

  $(document).on('click', function (e) {
    if (!$(e.target).closest('header, #MegaMenu').length) {
      if ($mega.hasClass('is-open')) closeMega();
    }
  });

  $(document).on('keyup', function (e) {
    if (e.key === 'Escape') closeMega();
  });

  $(window).on('scroll resize', updateMegaPositions);

  $mega.on('click', '.closeX', function (e) {
    e.preventDefault();
    closeMega();
  });

  //===== アイドル時間プリフェッチ & SWRを起動 =====
  const startPrefetch = () => {
    if (prefetchStarted) return;
    prefetchStarted = true;

    scheduleIdlePrefetch();
    scheduleRevalidate();
  };

  const bindStartPrefetchOnce = () => {
    const handler = () => startPrefetch();
    document.addEventListener('pointerdown', handler, { once: true, passive: true });
    document.addEventListener('scroll', handler, { once: true, passive: true });
    document.addEventListener('keydown', handler, { once: true, passive: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindStartPrefetchOnce, { once: true });
  } else {
    bindStartPrefetchOnce();
  }
}); // jQuery


//=============================================================
// フッター：遅延AJAX読み込み（汎用）
// - 対象要素の data-endpoint からHTML断片を取得
// - 500px手前で発火（IntersectionObserver）
//=============================================================
jQuery(function ($) {
  'use strict';

  function initLazyHtmlMount(selector, root) {
    var $root = root ? $(root) : $(document);
    var $mount = $root.find(selector);
    if (!$mount.length) return;

    if ($mount.data('loaded') === 1) return;

    var endpoint = $.trim($mount.attr('data-endpoint') || '');
    if (!endpoint) return;

    function afterInsert() {
      // カルーセル等が含まれる場合の再初期化
      if (typeof window.initSplideCarousels === 'function') {
        window.initSplideCarousels($mount[0]);
      }
    }

    function loadOnce() {
      if ($mount.data('loaded') === 1) return;
      $mount.data('loaded', 1);

      $.ajax({
        url: endpoint,
        type: 'GET',
        cache: false,
        dataType: 'html'
      })
        .done(function (html) {
          if (html && $.trim(html) !== '') {
            $mount.html(html);
            afterInsert();
          } else {
            $mount.empty();
          }
        })
        .fail(function () {
          $mount.empty();
        });
    }

    if ('IntersectionObserver' in window && $mount[0]) {
      if ($mount.data('io-bound') === 1) return;
      $mount.data('io-bound', 1);

      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          try {
            observer.unobserve(entry.target);
            observer.disconnect();
          } catch (e) {}
          loadOnce();
        });
      }, {
        root: null,
        rootMargin: '500px 0px',
        threshold: 0
      });

      observer.observe($mount[0]);
      return;
    }

    loadOnce();
  }

  function initFooterLazyBlocks(root) {
    initLazyHtmlMount('#UserViewedHistory', root);
    initLazyHtmlMount('#FooterSeisakuMenu', root);
    initLazyHtmlMount('#FooterPromotion', root);
  }

  // 初回
  initFooterLazyBlocks(document);

  // partial reload 対応（差し替わる場合に備える）
  document.addEventListener('partial:updated', function () {
    initFooterLazyBlocks(document);
  });
});


//=============================================================
// 固定フッター分(40px)を考慮したページ内スクロール（サインモール仕様）
//=============================================================
jQuery(function ($) {
  'use strict';

  const FOOTER_FIXED_HEIGHT = 40;
  const SCROLL_DURATION = 400;

  function scrollToId(selector) {
    if (!selector) return;

    const $target = $(selector);
    if (!$target.length) return;

    const docHeight = $(document).height() || 0;
    const winHeight = $(window).height() || 0;

    const targetTop = $target.offset().top || 0;

    let scrollTop = targetTop - FOOTER_FIXED_HEIGHT;

    if (scrollTop < 0) scrollTop = 0;

    const maxScroll = docHeight - winHeight;
    if (scrollTop > maxScroll) scrollTop = maxScroll;

    $('html, body').stop(true).animate(
      { scrollTop: scrollTop },
      SCROLL_DURATION
    );
  }

  $(document).on('click', '.scroll-to-id', function (e) {
    let selector = '';

    const dataTarget = $(this).data('scroll-target');
    if (dataTarget) {
      selector = dataTarget;
    } else if (this.tagName.toLowerCase() === 'a') {
      const href = $(this).get(0).getAttribute('href') || '';
      if (href.charAt(0) === '#') selector = href;
    }

    if (!selector) return;

    e.preventDefault();
    scrollToId(selector);
  });

  window.SignmallScroll = window.SignmallScroll || {};
  window.SignmallScroll.scrollToId = scrollToId;
});


